import React, {useEffect} from 'react';
import SearchableParticipantList from "../components/searchable-participant-list.jsx";
import {useToaster} from "../../global-components/toaster.jsx";

function LocalgroupParticipants({link, result, toast_message = ''}) {
    const { showToast } = useToaster();
    useEffect(() => {
        if (toast_message) {
            showToast(toast_message, 'success');
        }
    }, [toast_message]);
    return (
        <div>
            {result.event.groups.map((group, index) => (
                <SearchableParticipantList internal_name={result.internal_group_name} event_data={result.event.event} link={link} today={result.today} table_id="table_all_participants" group_data={group} />
            ))}
        </div>
    )
}

export default LocalgroupParticipants;
